import React from 'react'
import styled from 'styled-components'
import BlogSearch from './blog-search'
import HotTag from './hot-tag'
import Image from 'next/image'
import { shimmer, toBase64 } from '@/lib/utils'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'

type Params = {
  tags: any[]
}

const MobileMenu = (params: Params) => {
  const { width } = useWindowSize()
  if (!width) return null
  return (
    <BannerBox>
      <div className="mobile-content">
        <a href="https://www.facebook.com/KreditPintarOfficial/" rel="noopener noreferrer nofollow" target="_blank">
          <Image
            className="facebook-share"
            src={'/images/edu/facebook-share.png'}
            width={width > 1000 ? 200 : 272}
            height={width > 1000 ? 180 : 186}
            quality={80}
            placeholder="blur"
            blurDataURL={`data:image/svg+xml;base64,${toBase64(
              shimmer(width > 1000 ? 200 : 272, width > 1000 ? 200 : 186),
            )}`}
            alt="facebook-share"
          />
        </a>
        <BlogSearch />
        <HotTag tags={params.tags} />
      </div>
    </BannerBox>
  )
}

export default MobileMenu

const BannerBox = styled.div`
  @media only screen and (max-width: 1000px) {
    .mobile-content {
      text-align: center;
      .facebook-share {
        width: 320px;
        height: 220px;
      }
    }
    .h5 {
      display: none;
    }
  }
  @media only screen and (min-width: 1000px) {
    .mobile-content {
      .facebook-share {
        width: 200px;
        padding: 23px 0 12px !important;
      }
    }
  }
`
